import React, { useState, useCallback, useRef } from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReadOnlyPrimerGrid } from "../../components/grids";
import { EventRequestCard } from "../../components/event_requests/EventRequestCard";
import { CreateEventCard } from "../../components/events/CreateEventCard";

const queryClient = new QueryClient();

function EventRequestsGrid(props) {
  // GR-1702: My Requests is card-only; viewMode is pinned and the toggle is
  // hidden via the cardOnly prop (ReadOnlyPrimerGrid drops onViewModeChange).
  const cardOnly = props.cardOnly !== false;
  const [viewMode, setViewMode] = useState(props.defaultViewMode || "card");
  const searchTimeout = useRef(null);

  const renderCard = (row, columns) => <EventRequestCard row={row} columns={columns} />;

  // Leading "create request" card in card view, when the user may create.
  const leadingCard = props.newEventRequestUrl ? (
    <CreateEventCard
      href={props.newEventRequestUrl}
      label="Create New Event Request"
      subtitle="Submit an event for approval"
    />
  ) : undefined;

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearch = useCallback((query) => {
    clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => setSearchQuery(query), 300);
  }, []);

  let resultsUrl = props.resultsUrl;
  if (searchQuery) {
    const sep = resultsUrl.includes("?") ? "&" : "?";
    resultsUrl = `${resultsUrl}${sep}search=${encodeURIComponent(searchQuery)}`;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ReadOnlyPrimerGrid
        {...props}
        resultsUrl={resultsUrl}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
        cardOnly={cardOnly}
        renderCard={renderCard}
        leadingCard={leadingCard}
        onSearch={handleSearch}
        searchPlaceholder="Search Requests"
      />
    </QueryClientProvider>
  );
}

export class EventRequestsGridController extends ReactController {
  connect() {
    this.root.render(<EventRequestsGrid {...this.propsValue} />);
  }
}
